





















































import { Component, Prop, Vue } from "vue-property-decorator";
import { mask } from "vue-the-mask";
import { ValidationRules } from "_P/validate";
import { Car } from "@/services/index.defs";

@Component({ directives: { mask } })
export default class CarModel extends Vue {
    @Prop() car: Car;
    Rules = ValidationRules;
    get yearsItems(){
        let array = [];
        let currentYear = new Date().getFullYear();
        for(let i=0; i < 70; i++) {
            array.push(currentYear);
            currentYear--;
        }
        return array
    }
}
